import axios from 'axios'
import Auth from '../api/auth'
import { startSession, trackEvent } from '../Analytics.vue'

const ROUTE_TOOL_KEYS = {
  choose: 'admin_choose',
  upload: 'clip_upload',
  sourceInputs: 'source_inputs',
  snapshotBulk: 'snapshot_bulk_upload',
  snapshotCollectionPhotos: 'snapshot_photos',
  snapshotPhotoSetPhotos: 'snapshot_photos',
  snapshotProblems: 'snapshot_problems',
  snapshotConfiguration: 'snapshot_config',
  snapshotOperations: 'snapshot_operations',
  shareTemplates: 'share_presets',
  uploadNotifications: 'upload_notifications',
  imports: 'imports',
  importWizardNew: 'imports_new',
  importWizard: 'imports',
  ordersAnalytics: 'orders_analytics',
  analyticsDashboard: 'engagement_analytics',
  clipsExplorer: 'clips',
  customerOperations: 'customer_operations',
  userManagement: 'users',
  ceremonySearch: 'ceremony_intelligence',
}

let startedKey = ''

function decodeToken(raw) {
  try {
    if (!raw) return {}
    const part = raw.split('.')[1]
    if (!part) return {}
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decodeURIComponent(escape(json)))
  } catch {
    return {}
  }
}

export function adminContextFromToken(raw) {
  const token = raw || Auth.getToken()
  const payload = decodeToken(token)
  const roles = Array.isArray(payload.roles) ? payload.roles : []
  const universities = Array.isArray(payload.universities) ? payload.universities : []
  return {
    tenant: payload.tenant || '',
    adminUserId: payload.sub || '',
    roles,
    universities,
  }
}

export function toolKeyForRoute(route) {
  if (!route) return 'admin'
  if (route.name && ROUTE_TOOL_KEYS[route.name]) return ROUTE_TOOL_KEYS[route.name]
  const path = String(route.path || '')
  if (path.includes('/admin/upload')) return 'clip_upload'
  if (path.includes('/admin/source-inputs')) return 'source_inputs'
  if (path.includes('/admin/analytics')) return 'engagement_analytics'
  if (path.includes('/admin/order-analytics')) return 'orders_analytics'
  if (path.includes('/admin/snapshot-bulk')) return 'snapshot_bulk_upload'
  if (path.includes('/admin/snapshot-config')) return 'snapshot_config'
  if (path.includes('/admin/snapshot-operations')) return 'snapshot_operations'
  if (path.includes('/admin/share-templates')) return 'share_presets'
  if (path.includes('/admin/upload-notifications')) return 'upload_notifications'
  if (path.includes('/admin/imports')) return 'imports'
  if (path.includes('/admin/clips')) return 'clips'
  if (path.includes('/admin/customer-operations')) return 'customer_operations'
  if (path.includes('/admin/users')) return 'users'
  if (path.includes('/admin/ceremony-search')) return 'ceremony_intelligence'
  return 'admin'
}

export function startAdminAnalyticsSession(route) {
  const context = adminContextFromToken()
  const sessionKey = `${context.tenant}:${context.adminUserId}`
  if (!context.tenant || startedKey === sessionKey) return
  startedKey = sessionKey
  startSession(context.tenant, route || { path: '/admin' }, {
    adminSession: true,
    adminUserId: context.adminUserId,
    adminRoles: context.roles,
    adminUniversities: context.universities,
  })
}

export function trackAdminEvent(activityType, options = {}) {
  const context = adminContextFromToken()
  const toolKey = options.toolKey || toolKeyForRoute(options.route)
  const metadata = options.metadata || {}
  trackEvent((options.route && options.route.path) || (window.location && window.location.pathname) || '/admin', {
    label: activityType,
    tenant: context.tenant,
    adminSession: true,
    adminUserId: context.adminUserId,
    adminRoles: context.roles,
    adminUniversities: context.universities,
    tool_key: toolKey,
    ...metadata,
  })
  if (!context.tenant) return Promise.resolve(false)
  return axios.post('/admin/search', {
    mode: 'admin_activity',
    activityType,
    toolKey,
    metadata,
  }).then(() => true).catch(() => false)
}
